var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-center-container",class:_vm.device.isMobile ? 'title-center-container-mobile' : '',attrs:{"id":_vm.content.key}},[_c('span',{staticClass:"title-text",style:({
        position: 'relative',
        display: 'inline-block',
        fontFamily: _vm.content.textStyle.fontFamily || '',
        fontSize: _vm.content.textStyle.fontSize + 'rem' || '',
        minHeight: _vm.content.textStyle.height + 'rem' || '',
        lineHeight: _vm.content.textStyle.lineHeight + 'rem' || '',
        maxWidth: _vm.content.textStyle.maxWidth + 'rem' || '',
        textIndent:
          _vm.content.textStyle.textIndent &&
          typeof _vm.content.textStyle.textIndent === 'string'
            ? _vm.content.textStyle.textIndent
            : _vm.content.textStyle.textIndent &&
              typeof _vm.content.textStyle.textIndent === 'number'
            ? _vm.content.textStyle.textIndent + 'rem'
            : '',
        fontWeight: _vm.content.textStyle.fontWeight || '',
        textDecoration: _vm.content.textStyle.underline === 1 ? 'underline' : '',
        fontStyle: _vm.content.textStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: _vm.content.textStyle.textAlign || '',
        color: _vm.content.textStyle.color || '',
        backgroundColor: _vm.content.textStyle.backgroundColor || '',
        backgroundImage: _vm.content.textStyle.backgroundImage
          ? ("url(" + (_vm.content.textStyle.backgroundImage) + ")")
          : '',
        borderRadius: _vm.content.textStyle.borderRadius
          ? _vm.content.textStyle.borderRadius.borderTopLeftRadius +
            'rem' +
            ' ' +
            (_vm.content.textStyle.borderRadius.borderTopRightRadius + 'rem') +
            ' ' +
            (_vm.content.textStyle.borderRadius.borderBottomRightRadius + 'rem') +
            ' ' +
            (_vm.content.textStyle.borderRadius.borderBottomLeftRadius + 'rem')
          : '',
        padding: _vm.content.titleImageType == 3 ? '10rem 12rem' : _vm.content.titleImageType == 4 ? '0 37rem 0 18rem' : '',
        margin: _vm.content.textStyle.margin + 'rem' || '',
        marginTop: _vm.content.textStyle.marginTop + 'rem' || '',
        marginBottom: _vm.content.textStyle.marginBottom + 'rem' || '',
        border: _vm.content.textStyle.border || '',
      }),attrs:{"id":((_vm.content.key) + "-1")}},[(_vm.content.shortText)?_c('span',{attrs:{"id":((_vm.content.key) + "-1-1")},domProps:{"innerHTML":_vm._s(_vm.content.shortText)}}):_vm._e(),_c('span',{class:_vm.content.titleImageType == 2 ? 'active' : '',attrs:{"id":((_vm.content.key) + "-1-2")},domProps:{"innerHTML":_vm._s(_vm.content.text)}}),(_vm.content.titleImage && _vm.content.titleImageType == 1)?_c('img',{style:({
          width: '80rem',
          height: _vm.content.textStyle.height + 'rem' || '',
          position: 'absolute',
          top: 0,
          right: '-80rem',
        }),attrs:{"src":_vm.content.titleImage,"alt":""}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }